import {RECEIVE_CONFIG_SITE, RECEIVE_TEMPLATE} from '../actions/action-types';

export default function config(state = {}, action) {
    switch (action.type) {
        case RECEIVE_CONFIG_SITE:
            return {
                ...state,
                site: action.site,
                context: action.context
            };
        case RECEIVE_TEMPLATE:
            return {
                ...state,
                template: action.template
            };
        default:
            return state;
    }
}
